import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit/responsive/hooks/useDeviceType';

import { ETab } from '../../types/tab';
import { Tabs } from '../../components/Tabs';
import { getActiveTab } from '../../selectors/tabs';
import { setActiveTabAction } from '../../actions/tabs';
import { getActiveSort } from '../../selectors/sort';
import { QUESTION_TAB_EXCLUDED_SORT } from '../../constants/tabs';
import { ESortType } from '../../types/sort';
import { setActiveSort } from '../../actions/sort';
import { getReviewsCount } from '../../selectors/newbuildingInfo';
import { getQuestionsCount } from '../../selectors/newbuildingInfo/getQuestionsCount';

export const TabsContainer = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const deviceType = useDeviceType();
  const tab = useSelector(getActiveTab);
  const sort = useSelector(getActiveSort);
  const reviewsCount = useSelector(getReviewsCount);
  const questionsCount = useSelector(getQuestionsCount);

  const isMobile = deviceType === 'phone';

  const onTabChange = (value: ETab) => {
    const isExcludedSort = QUESTION_TAB_EXCLUDED_SORT.includes(sort?.type as ESortType);
    if (value === ETab.Questions && isExcludedSort) {
      dispatch(setActiveSort(ESortType.Default));
    }

    dispatch(setActiveTabAction(value));
  };

  return (
    <Tabs
      activeTab={tab}
      onChange={onTabChange}
      isMobile={isMobile}
      reviewsCount={reviewsCount}
      questionsCount={questionsCount}
    />
  );
};
